import React from 'react';
import './subjects.scss';
import AddressTab from  './addressTab.js';
import OrdersTab from './ordersTab.js';

//import { Logout, valutaOptions, formeGiuridicheOptions, modalitàPagamentoOptions } from '../../globals';
import {handleAuthError, useCheckUserAuthentication,fetchLookup,valutaOptions, formeGiuridicheOptions, modalitàPagamentoOptions} from '../../globals';
//import { useAuth } from  '../../contexts/auth'; 

import DataGrid, {
  Column,
  Export,
  //Button,
  Popup,
  Form,
  Pager,
  Paging,
  Toolbar,
  HeaderFilter,
  Lookup,
  Editing,
  Selection,
  Summary,
  CustomRule,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';


//import {Toolbar} from 'devextreme-react/toolbar';
import { SimpleItem, GroupItem, Item,TabbedItem, TabPanelOptions, Tab } from 'devextreme-react/form';
//import { CheckBox } from 'devextreme-react/check-box';
import { useState, useEffect } from 'react';
import {useNavigate} from 'react-router-dom';

//npm install exceljs
import { Workbook } from 'exceljs';
//npm install file-saver --save
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

import { createStore } from 'devextreme-aspnet-data';

//import { EmptyItem } from 'devextreme-react/form';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica'





export default function Anagrafica() {

  var dataGridRef = React.createRef();
  const navigate = useNavigate();
  
  const [isFornitore, setIsFornitore] = useState(false);
  const [nazioni, setNazioni] = useState({});
  const [province, setProvince] = useState({});

  const [showEdit, setShowEdit] = useState(false);
  const [currentRow, setCurrentRow] = useState();
  const [currentName, setCurrentName] = useState();
  const [intermediari, setIntermediari] = useState({});
  const [intermediarioFilter, setIntermediarioFilter] = useState(0);

  const user = useCheckUserAuthentication();

  useEffect(() => {

    const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Nazione';
    var newUrl1 =  newServiceUrl1 + "/GetAction";

    const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Provincia';
    var newUrl2 =  newServiceUrl2 + "/GetAction";

    const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

    const fetchData = async () => {
      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response1 = await fetch(newUrl1);
        const json1 = await response1.json();
        //console.log(json1);
        setNazioni(json1);

        const response2 = await fetch(newUrl2);
        const json2 = await response2.json();
        //console.log(json2);
        setProvince(json2);

        const json7 = await fetchLookup(newUrl7,requestOptions);
        if (json7) {
          setIntermediari(json7);
        }

      } catch (error) {
        console.log("error", error);
      }
    };
      fetchData();
    }, [user?.token]); // Aggiorna se il token cambia

  function onToolbarPreparing(e) {

    e.toolbarOptions.items.push({
        widget: 'dxButton',
        name: "myexport",
        location: "before",
        options: {
            icon: "exportxlsx",
            hint: "Esporta in Excel",
            onClick: function() {
              onExporting(e);
            }
        }
    });
  }

  function onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Anagrafica.xlsx');
      });
    });
    e.cancel = true;
  }


  const filterPayload = { 
    intermediario: intermediarioFilter
  };

  const remoteDataSource = createStore({
    key: 'id',
    //loadUrl: serviceUrl + '/GetAction',
    loadUrl: serviceUrl + '/Find',
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction',
    
    errorHandler: (error) => {
      handleAuthError(error);
    }
    
});

function onRowSelectionChanged({ selectedRowsData }) {

  const data = selectedRowsData[0];
  if (data !== undefined)
    {
    setCurrentRow(data.id);
    setCurrentName(data.ragioneSociale);
    //setShowEdit(true);
  }

}

function onRowInserting(e) {
  e.data.updateBy = user.name;
};

function onRowUpdating(e) {
  e.newData.updateBy = user.name;
};

// function RenderPopUp() {
//   const titolo = "&nbsp;&nbsp;&nbsp;Anagrafica " + {currentName};
//   return(<Popup title={titolo}  showTitle={true} width={900} height={525} />)
// }



const notesEditorOptions = { height: 100 };

function renderLeft() {
  return <div className="toolbar-label">Commesse</div>;
}

function renderRight() {
  return <div className="toolbar-label">Documenti</div>;
}

function renderTitle() {
  return <div className="toolbar-label"><b><h4>{currentName}</h4></b></div>;
}

const backButtonOptions = {
  type: 'default',
  text: '',
  icon: 'back',
  onClick: () => {
    //navigate("/students",{ state: {searchText: searchPanelValue}});
    navigate("/projects");
    //notify('Back button has been clicked!');
  },
};

const forwardButtonOptions = {
  type: 'default',
  icon: 'chevronnext',
  text: '',
  //width: 100,
  onClick: () => {
    //navigate("/features",{ state: {itemId: idAnagrafica, itemAllievoId: idAllievo, itemTestataId: idTestata}});
    navigate("/documents");
    //notify('Forward button has been clicked!');
  },
};

function validateAlias (e) {  

  if(e.data.costruttore === false)  
    return true;  
  else 
    if (e.value !== null && e.value !== "")
      return true;
    else
      return false
}  


const selectBoxOptions2 = {
  width: 210,
  items: intermediari,
  valueExpr: 'id',
  displayExpr: 'ragioneSociale',
  placeholder:"<Azienda>",
  showClearButton:true,
  onValueChanged: (args) => {
    setIntermediarioFilter(args.value);
  },
  value: intermediarioFilter,
};


const addButtonOptions = {
  icon: 'plus',
  hint: 'Nuovo Soggetto'
};

  return (
  <React.Fragment>
    <h2 className={'content-block'}>Anagrafica</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>

    


      <DataGrid
        ref={ref => dataGridRef = ref}
        //solo se dati locali
        //keyExpr="id"
        className={'dx-card wide-card'}
        dataSource={remoteDataSource}
        showBorders={false}
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        //remoteOperations={true}
        onSelectionChanged={onRowSelectionChanged}
        onExporting={onExporting}
        onToolbarPreparing = {onToolbarPreparing}
        onRowInserting = {onRowInserting}
        onRowUpdating = {onRowUpdating}
        dateSerializationFormat= {'yyyy-MM-dd'}
      >
        <Paging defaultPageSize={20} />
        <Pager showPageSizeSelector={true} showInfo={true} />
      
        <Toolbar>
          <Item name="addRowButton"  options={addButtonOptions} location="before"/>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions2} >
            </Item>
            <Item name="searchPanel" className="offer-toolbar"/>
        </Toolbar>
        <SearchPanel visible={true}
          width={240}
          placeholder="Cerca..."
          //text={searchPanelValue} 
        />
        <HeaderFilter visible={true} />
        <Summary>
          <TotalItem
              column="codice"
              summaryType="count"
          />
        </Summary>
        <Selection mode="single" />
        <Editing
          mode="popup"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}     
        >
          
          <Popup   title= "&nbsp;&nbsp;&nbsp;Anagrafica " showTitle={true} width={900} height={725} />
         
          <Form>
            <Item itemType="group" caption="Denominazione" colCount={2} colSpan={2}>
         
              <Item dataField="ragioneSociale" colSpan={2}/>
              <Item dataField="nome" />  
              <Item dataField="cognome" />  
              <Item dataField="codice" />  
              <Item dataField="alias"/>
              <Item dataField="formaGiuridicaId" editorType="dxSelectBox" />  
              <Item dataField="aziendaId" editorType="dxSelectBox" />  
              <Item dataField="cliente"/>
              <Item dataField="fornitore"/>
              <Item dataField="concorrente"/>
              <Item dataField="partner"/>
              <Item dataField="costruttore"/>
              <Item type="empty"/>
             
         
              <Item dataField="note" colSpan={2} editorType="dxTextArea" />
             
            </Item>  
            <Item itemType="group" caption="Recapiti" colCount={2} colSpan={2}>
              <Item dataField="telefono"/>
              <Item dataField="cellulare" />
              <Item dataField="fax" />
              <Item dataField="email" />
              
              <Item dataField="sitoWeb" />
            </Item>
            <Item itemType="group" caption="Localizzazione" colCount={2} colSpan={2}>

              <Item dataField="indirizzo"/>
              <Item dataField="civico" />
              <Item dataField="città" />
              <Item dataField="cap"/>
              <Item dataField="provinciaId"
                editorType="dxSelectBox"
                editorOptions={province} displayExpr="codice" valueExpr="id"/>
              <Item dataField="nazioneId"
                    editorType="dxSelectBox"
                    editorOptions={nazioni} displayExpr="codice" valueExpr="id" isRequired= "true"/>  
              <Item dataField="noteIndirizzo" colSpan={2}/>
                 
            </Item>
            <Item itemType="group" caption="Dati Fiscali" colCount={2} colSpan={2}>
              <Item dataField="piva" caption="P.IVA"/>
              <Item dataField="cf" caption="C.F."/>
              <Item dataField="pec" />
              <Item dataField="codiceDestinatario"/>
              <Item dataField="cciaa" />
              <Item dataField="registroImprese" />
            </Item>

            <Item itemType="group" caption="Dati amministrativi" colCount={2} colSpan={2}>

            <Item dataField="condizioniPagamentoId"
                    editorType="dxSelectBox"
                    editorOptions={modalitàPagamentoOptions} displayExpr="desc" valueExpr="id"/>  
              <Item dataField="valutaId"
                    editorType="dxSelectBox"
                    editorOptions={valutaOptions} displayExpr="desc" valueExpr="id"/>  
              <Item dataField="banca" />
              <Item dataField="iban" />
            </Item>
           

          </Form>
        </Editing>
          
     
        <Column dataField="id" visible={false}></Column>
        <Column dataField="codice" allowEditing={false}></Column>
        
      <Column
        dataField="ragioneSociale"
        caption="Ragione sociale"
        calculateDisplayValue={(rowData) =>
          rowData.ragioneSociale
            ? rowData.ragioneSociale
            : `${rowData.cognome ?? ""} ${rowData.nome ?? ""}`.trim()
        }
      />
        <Column dataField="nome" visible={false}></Column>
        <Column dataField="cognome" visible={false}></Column>
        <Column dataField="alias" visible={false}>
          <CustomRule message="Il campo alias è obbligatorio per i Costruttori" validationCallback={validateAlias} />     
        </Column>
        <Column dataField="cliente" caption="Cliente"></Column>
        <Column dataField="fornitore"caption="Fornitore"></Column>
        <Column dataField="concorrente"caption="Concorrente" visible={false}></Column>
        <Column dataField="partner"caption="Partner" ></Column>
        <Column dataField="costruttore"caption="Costruttore"visible={true}></Column>
        <Column dataField="piva" caption="P.IVA"></Column>
        <Column dataField="cf" caption="C.F."></Column>
        <Column dataField="indirizzo"></Column>
        <Column dataField="civico"></Column>
        <Column dataField="città"></Column>
        <Column dataField="provinciaId" caption="Provincia" >
          <Lookup dataSource={province} displayExpr="codice" valueExpr="id" />
        </Column>
        <Column dataField="cap"></Column>
        <Column dataField="nazioneId" caption="Nazione" >
          <Lookup dataSource={nazioni} displayExpr="descrizione" valueExpr="id" />
        </Column>
        <Column dataField="telefono"></Column>
        <Column dataField="cellulare"></Column>
        <Column dataField="fax"></Column>
        <Column dataField="email"></Column>
        <Column dataField="sitoWeb" visible={false}></Column>
        <Column dataField="pec"visible={false}/>
        <Column dataField="codiceDestinatario" visible={false}/>
        <Column dataField="cciaa" visible={false}/>
        <Column dataField="registroImprese" visible={false}/>
        <Column dataField="note" visible={false}></Column>

        <Column dataField="valutaId" caption="Valuta" visible={false}>
          <Lookup dataSource={valutaOptions} displayExpr="desc" valueExpr="id" />
        </Column>
        <Column dataField="condizioniPagamentoId" caption="Modalità pagamento" visible={false}>
          <Lookup dataSource={modalitàPagamentoOptions} displayExpr="desc" valueExpr="id" />
        </Column>
        <Column dataField="formaGiuridicaId" caption="Forma Giuridica" visible={false}>
          <Lookup dataSource={formeGiuridicheOptions} displayExpr="desc" valueExpr="id" />
        </Column>
        <Column dataField="aziendaId" caption="Azienda" width={240} visible={false} editorOptions={{ showClearButton: true }} >
          <Lookup dataSource={intermediari} valueExpr="id" displayExpr="ragioneSociale" />
        </Column>

        <Column dataField="latitudine" visible={false}/>
        <Column dataField="longitudine" visible={false}/>
        <Column dataField="banca" visible={false}/>
        <Column dataField="iban" visible={false}/>

        <Export enabled={true} allowExportSelectedData={false} />
      </DataGrid>

      </div>
    </div>
  </React.Fragment>
)};
